export const gitVersion = {
  "commit": "3a949b0",
  "commitLong": "3a949b0f84a146b04c4e461b4b4780e9249c53d5",
  "branch": "develop"
}